import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import dayjs from "dayjs"
import { useMemo } from "react"
import { useThisMinute } from "src/hooks/time"

/*
 * returns true if the last_pump_event_at was more than 24 hours ago
 */
export function useIsPumpStatusSensorExpirationStale(pumpStatus: PumpStatus): boolean {
  const { last_pump_event_at: syncedAt } = pumpStatus
  const thisMinute = useThisMinute()

  return useMemo(
    () => {
      if (syncedAt === null) {
        return true
      }

      return dayjs(thisMinute).diff(
        syncedAt,
        "hours",
        true,
      ) > 24
    },
    [
      thisMinute,
      syncedAt,
    ],
  )
}
